export default {

    indexOfferItemThemeCores:   { method: 'get',    url: 'offer_item_theme_cores' },
    storeOfferItemThemeCore:    { method: 'post',   url: 'offer_item_theme_cores' },
    updateOfferItemThemeCore:   { method: 'put',    url: 'offer_item_theme_cores/{id}'},
    destroyOfferItemThemeCore:  { method: 'delete', url: 'offer_item_theme_cores/{id}'},

}